<template>
    <div class="quotesinfo">
        <b-navbar toggleable="lg" class="border-bottom pb-0 mb-0 mt-0 pt-0" type="dark" variant="info">
       <b-navbar-brand class="d-block d-md-none d-lg-none" href="#"><router-link class="link" to="/"><img class="logo" :src="'https://admin.promagic.hu/api/uploads/'+companyData.logo_src"></router-link></b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"><b-icon-list></b-icon-list></b-navbar-toggle>
    <b-collapse id="nav-collapse" class="container" is-nav>
      <b-navbar-nav>
        <b-nav-item class="pl-2 pr-2 border-left-own d-none d-lg-block d-md-block" href="#"><router-link class="link" to="/"><img class="logo" :src="'https://admin.promagic.hu/api/uploads/'+companyData.logo_src"></router-link></b-nav-item>
        <b-nav-item-dropdown class="pl-2 pr-2 border-left-own" text="Árajnálat kérés" left>
          <b-dropdown-item v-for="item in templateData" :key="item.sablon_id"><a class="link text-dark" @click="goToTemplates(item.sablon_id)">{{item.sablon_nev}}</a></b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item class="pl-2 pr-2 border-left-own"><router-link class="link" style="color:black" to="/">Árajánlatok</router-link></b-nav-item>
        <b-nav-item class="pl-2 pr-2 border-left-own"><router-link class="link" style="color:black" to="/deliveryNotes">Szállítólevelek</router-link></b-nav-item>
        <b-nav-item class="pl-2 pr-2 border-left-own" v-b-modal.modal-1>Beállítások</b-nav-item>
        <b-nav-item class="pl-2 pr-2 border-left-own border-right-own" @click="logout">Kijelentkezés</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
        <div class="container mt-3">            
            <div class="row">
                <div class="col-lg-12 row">
                    <h5 class="mt-3 mb-4">{{this.templateInfo['sablon_nev']}}</h5>
					<div class="row col-lg-12">
						<label class="col-lg-6">
							Megnevezés
							<b-form-input v-model="name" placeholder=""/>
						</label>
					</div>
					<div class="row col-lg-12" v-for="item in this.templateOtherInfo" :key="item.sorszam">
						<label class="col-lg-12">
							{{item.mezo_nev}}	
							<div class="col-lg-6 pl-0" v-if="item.select == null">
								<b-form-input placeholder="" v-model="item.mezo_alap_ertek"/>
							</div>
							<div class="col-lg-6 pl-0" v-else>
								<b-form-select v-model="item.selected" :options="item.select"></b-form-select>
							</div>
						</label>
					</div>
					<label class="col-lg-3">
							<img v-if="this.templateInfo['kep'] != ' '" class="w-100 mt-2 mb-2" :src="'https://admin.promagic.hu/api/uploads/'+this.templateInfo['kep']">
						</label>
					<div class="col-lg-12">
						<b-button variant="success" @click="createNewQuotes">Ajánlat küldése</b-button>
					</div>
                </div>
                </div>
            </div>
        <SettingsModal/>
    </div>
</template>
<script>
import router from "../router"
import axios from 'axios'
import SettingsModal from '../components/SettingsModal.vue'
export default {
  components: {
    SettingsModal
  },
  name: 'template',
data(){
    return {
		templateInfo:[],
		templateOtherInfo:[],
		name:"",
		companyData:[

        ],
        templateData:[
            
        ],
      }
    },
    computed: {
      
	},
    methods:{
		goToTemplates(id){
			router.push({ name: 'Template', params: { id: id }})
			this.getTemplateData()
			this.getTemplateOtherData()
		},
        logout(){
            this.$session.remove('id')
            router.push({ path: `/login` })
        },
        getCompanyData(){
            const params = new URLSearchParams();
            params.append('getCompanyData', true);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_LOGIN_API,
                data:params
            }).then((response) => {
                this.companyData = response.data[0]
            })
		},
		getTemplateDataMenu(){
            const params = new URLSearchParams();
            params.append('getAllTemplate', true);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_TEMPLATE_API,
                data:params
            }).then((response) => {
        this.templateData = response.data
        console.log(this.templateData);
            })
        },
		createNewQuotes(){
			if(this.name == ""){
				this.$swal('Hiba történt', 'Minden mező kitöltése kötelező' ,'error')
			}else{
				const params = new URLSearchParams();
				params.append('uploadNewTemplateQuotes', true);
				params.append('templateID', this.$route.params.id);
				params.append('user_id', this.$session.get('id'));
				params.append('answers', JSON.stringify(this.templateOtherInfo).toString());
				params.append('name', this.name)
				axios({
					method: 'post',
					url: process.env.VUE_APP_TEMPLATE_API,
					data:params
				}).then(() => {
					this.getTemplateData()
					this.getTemplateOtherData()
					this.name = "";	
					this.$swal('Árajánlat kérdésed elküldve', 'Hamarosan felvesszük veled a kapcsolatot' ,'success')
				})
			}
		},
        getTemplateData(){
			const params = new URLSearchParams();
			params.append('getThisTemplateData', true);
			params.append('templateID', this.$route.params.id);
            axios({
                method: 'post',
                url: process.env.VUE_APP_TEMPLATE_API,
                data:params
            }).then((response) => {
				this.templateInfo=response.data
            })
		},
		getTemplateOtherData(){
			const params = new URLSearchParams();
            params.append('getThisTemplateOtherData', true);
			params.append('templateID', this.$route.params.id);
            axios({
                method: 'post',
                url: process.env.VUE_APP_TEMPLATE_API,
                data:params
            }).then((response) => {
				this.templateOtherInfo=response.data
            })
		},
    },
    mounted(){
		this.getTemplateData()
		this.getTemplateOtherData()
		this.getCompanyData();
		this.getTemplateDataMenu()
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Merienda&display=swap');
.bg-light-gray{
    background:#e5e5e5;
}
.left-data{
    font-weight: bold;
    font-size: 12pt;
}
.border-left-own{
  border-left: 1px solid #dee2e6;
}
.border-right-own{
  border-right: 1px solid #dee2e6;
}
@media only screen and (max-width : 550px) {
  .border-left-own{
    border-left: none !important;
  }
  .border-right-own{
    border-right: none !important;
  }
}
</style>
